import axios from "axios";
import { handleAPIError, handleAPISuccess } from "./utils/utilsAPI";
import { blockUserValidation, createUserValidation, hostIdValidation, phoneNumberValidation, tokenAndIdValidation, validateEmail } from "./utils/validateAPI";
import { BASE_URL, getConfig, TEST_URL } from "./constant";

const token = "8lQzN922rpRDaMbh3m5J";

const apiUser = axios.create({
  baseURL: `${TEST_URL}/users`,
});

/**
 * validates the argument received and Makes an API call to create or update the User
 * @param {object} userDetail - contains all the data required to create a user
 * @returns {Promise} - Resolves when the promise returns user details  or logs in case of failure.
 */
const createUser = async (userDetail) => {
  try {
   
    console.log("payload userDetail: ",userDetail);
    
    await createUserValidation.validate(userDetail);
    const res = await apiUser.post(`/add`, userDetail, getConfig());
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the user
 * @param {string} id - id of the charger to get the particular user details or "all" to get all the user
 * @returns {Promise} - Resolves when the promise returns all the chargers or empty array in case of no charger or logs in case of failure.
 */
const getUser = async (id) => {
  const payload = {
    // token: token,
    hostId: id,
  };
  try {
    await hostIdValidation.validate(payload);
    const res = await apiUser.get(`/all`, { params: payload,...getConfig() });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const getUserByRFID = async (id) => {
  const payload = {
    // token: token,
    idTag: id,
  };
  try {
    // await idTagValidation.validate(payload);
    const res = await apiUser.get(`/byRFID`, { params: payload,...getConfig() });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to delete the user
 * @param {string} id - id of the charger to delete the user
 * @returns {Promise} - Resolves when the promise returns id of the user or logs in case of failure.
 */
const deleteUser = async (id) => {
  const payload = {
    // token: token,
    phoneNumber: id,
  };
  try {
    await phoneNumberValidation.validate(payload);
    const res = await apiUser.delete(`/delete`, { params: payload ,...getConfig()});
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const blockOrUnblockUser = async (userDetail) => {
  try {
    
    await blockUserValidation.validate(userDetail);
    const res = await apiUser.post(`/updateStatus`, userDetail, getConfig());
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const getTransactionByUserId = async (id) => {
  const payload = {  phoneNumber: id };
  try {
    // await tokenAndIdValidation.validate(payload);
    const res = await apiUser.get(`/getTransactions`, { params: payload ,...getConfig()});
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

export { createUser, getUser, deleteUser,blockOrUnblockUser,getUserByRFID ,getTransactionByUserId};
